import React, { useRef } from 'react';
import { IoClose } from 'react-icons/io5';
import { useDisplayWidgetContext } from '../../DisplayWidget/utils/context';
import { calculatePrice, PriceDisplay } from '../../../Helpers/Helpers';
import { getCurrentSymbol } from '../../../Helpers/Helpers';
import LazyImage from '../../LazyImage';

const ShopifyProductMobile = React.lazy(() => import('./ShopifyProductMobile'));

export default function SpecialProductMobileOverlay({
  isOpen,
  row,
  product,
  setProduct,
  shopifyData,
  activeIndex,
  albumData,
}) {
  const { layout, data, isWooCommerceSite, isShopify } = useDisplayWidgetContext();
  const websiteArr = ['widget.idukki.io', 'widget-staging.idukki.io'];
  const ShopBtnComponent = ({ product }) => {
    const btnRef = useRef();

    return (
      <>
        <style>{`
        .idk_shop_now_btn {
        ${layout?.productsSettings?.shopBtnCss}
        }
        `}</style>
        <idk-div
          ref={btnRef}
          onClick={() => {
            const shopBtnFunctionality = layout?.productsSettings?.shopBtnFunctionality;
            if (shopBtnFunctionality) {
              try {
                const func = new Function('postData', 'productData', 'current', shopBtnFunctionality);
                func(row, product, btnRef);
              } catch (error) {
                console.error('Error executing shopBtnFunctionality', error);
              }
            } else {
              window.open(
                product?.product_url
                  ? `${product.product_url}?utm_source=${
                      layout?.gallerySettings?.utmSource || 'IdukkiUGC'
                    }&utm_medium=${layout?.gallerySettings?.utmMedium || 'AddToCart'}&utm_campaign=${
                      layout?.gallerySettings?.utmCampaign || 'ShoppableVideosHomepage'
                    }`
                  : !websiteArr.includes(window.location.hostname)
                  ? `https://${window.location.hostname}`
                  : 'https://app.idukki.io/register',
                '_blank',
              );
            }
          }}
          class="zid-rounded-md zid-bg-blue-600 zid-px-4 zid-py-1 zid-text-[12px]  zid-cursor-pointer idk_shop_now_btn"
        >
          {layout?.productsSettings?.shopBtnText}
        </idk-div>
      </>
    );
  };
  if (!isOpen) {
    return <></>;
  }
  return (
    <idk-div
      class={`${
        product
          ? 'zid-h-[75vh] zid-overflow-auto zid-absolute zid-bottom-0 zid-left-1/2 zid-w-full zid-bg-[#ffffff] zid-rounded zid-mobile-drawer'
          : 'zid-h-0 zid-overflow-hidden'
      }`}
      style={{ transform: 'translateX(-50%)', transition: 'height 1s ease-in-out', zIndex: '9999999' }}
    >
      <idk-div class="zid-sticky zid-top-0 zid-z-[100] zid-text-lg zid-flex zid-items-center zid-justify-between zid-p-3 zid-bg-white">
        <b>Shop Now</b>
        <IoClose
          color="#000000"
          fontSize={24}
          onClick={() => {
            setProduct(null);
          }}
        />
      </idk-div>
      <idk-div class="zid-p-3">
        <idk-div class="zid-flex zid-flex-col zid-w-full zid-gap-4 zid-mt-4">
          {isShopify ? (
            <ShopifyProductMobile
              row={row}
              shopifyData={shopifyData}
              product={product}
              activeIndex={activeIndex}
              albumData={albumData}
            />
          ) : (
            <>
              {row?.products?.map((product, id1) => {
                return (
                  <idk-div key={id1} class="zid-flex zid-w-full zid-justify-between zid-gap-2">
                    {product?.images && (
                      <idk-div
                        class=" zid-rounded zid-flex zid-items-center zid-white"
                        style={{ width: '80px', height: '80px', overflow: 'hidden', flex: '0 0 80px' }}
                      >
                        <LazyImage
                          src={product?.images[0]?.image_url?.replaceAll('resize/800x800', 'resize/64x64')}
                          className="zid-w-full zid-h-full zid-object-contain"
                          loading="lazy"
                          style={{}}
                          alt={product?.title}
                        />
                      </idk-div>
                    )}
                    <idk-div
                      class="zid-flex zid-gap-[10px] zid-text-[12px] zid-flex-col zid-overflow-hidden"
                      style={{ flexGrow: 1 }}
                    >
                      <idk-p class="zid-font-bold">{product?.title}</idk-p>
                      {product?.description &&
                        product?.description?.trim() &&
                        layout?.productsSettings?.showProductDescription && (
                          <idk-p dangerouslySetInnerHTML={{ __html: product?.description }}></idk-p>
                        )}
                      <idk-div class="idk_btn_price_container">
                        {product?.variants && (
                          <idk-p class="zid-mt-1 zid-p-0 zid-mb-0" style={{ fontWeight: 500, fontSize: '14px' }}>
                            {isWooCommerceSite() &&
                              !data.result.currency &&
                              document?.getElementsByClassName('woocommerce-Price-currencySymbol')?.[0]?.innerHTML}
                            {shopifyData?.currency?.active &&
                              !data.result.currency &&
                              getCurrentSymbol(shopifyData?.currency?.active, shopifyData?.locale)}
                            <span className="zid-font-bold">
                              {shopifyData ? (
                                calculatePrice(
                                  parseFloat(product?.variants?.[0]?.price) / 100,
                                  parseFloat(shopifyData?.currency?.rate),
                                )
                              ) : (
                                <PriceDisplay
                                  price={product?.variants?.[0]?.price}
                                  salePrice={product?.variants?.[0]?.salePrice}
                                  currency={data.result.currency}
                                />
                              )}
                            </span>
                          </idk-p>
                        )}
                        <idk-div class="zid-flex  zid-items-center zid-mt-1">
                          <ShopBtnComponent product={product} />
                        </idk-div>
                      </idk-div>
                    </idk-div>
                  </idk-div>
                );
              })}
            </>
          )}
        </idk-div>
      </idk-div>
    </idk-div>
  );
}
